// selectedBookingSlice.ts
import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: { loading: false },
  reducers: {
    setAuth(state, action) {
      state.jwt = action.payload;
      state.isLoggedIn = action.payload ? true : false;
    },
    setLoading(state, action) {
      state.loading = action.payload ? true : false;
    },
    setIsAdmin(state, action) {
      state.isAdmin = action.payload ? true : false;
    },
  },
});

export const { setAuth, setLoading, setIsAdmin } = authSlice.actions;
export default authSlice.reducer;
